import { DestroyRef, Directive, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { TranslocoService } from '@ngneat/transloco';
import { of } from 'rxjs';
import { catchError, distinctUntilChanged, switchMap } from 'rxjs/operators';

@Directive({
  selector: '[appRemountOnLanguageChange]',
  standalone: false,
})
export class RemountOnLanguageChangeDirective implements OnInit {
  constructor(
    private templateRef: TemplateRef<unknown>,
    private viewContainer: ViewContainerRef,
    private translocoService: TranslocoService,
    private destroyRef: DestroyRef,
  ) {}

  ngOnInit(): void {
    this.translocoService.langChanges$
      .pipe(
        distinctUntilChanged(),
        switchMap((lang) => this.translocoService.load(lang).pipe(catchError(() => of(undefined)))),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe(() => {
        this.viewContainer.clear();
        this.viewContainer.createEmbeddedView(this.templateRef);
      });
  }
}
